import { render, staticRenderFns } from "./OpenAmountsTotal.vue?vue&type=template&id=6ab59143&"
import script from "./OpenAmountsTotal.vue?vue&type=script&lang=js&"
export * from "./OpenAmountsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports